import { render } from "./open-transactions.vue?vue&type=template&id=5ccc433b"
import script from "./open-transactions.vue?vue&type=script&lang=js"
export * from "./open-transactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__